module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Section":"Section","Heading":"Heading","Content":"Content","Hyperlink (optional)":"Hyperlink (optional)"},"de":{"Teaser":"Anreißer","Basic Information":"Grundeinstellung","Section":"Sektion","Heading":"Überschrift","Content":"Inhalt","Hyperlink (optional)":"Hyperlink (optional)"}}')
  delete Component.options._Ctor
}
